(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollectionTabs(section) {
      var tabs = section.querySelectorAll('.collection-tabs__tab');
      var panels = section.querySelectorAll('.collection-tabs__panel');
      if (!tabs.length || !panels.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-tab-target');
          if (!targetId) return;

          var activePanel = section.querySelector('.collection-tabs__panel.is-active');
          var nextPanel = section.querySelector('[data-tab-panel="' + targetId + '"]');
          if (!nextPanel || nextPanel === activePanel) return;

            tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          // Bring the active tab (and its neighbours) into view on mobile
          var tabsStrip = section.querySelector('.collection-tabs__tabs');
          if (tabsStrip) {
            var stripRect = tabsStrip.getBoundingClientRect();
            var tabRect = tab.getBoundingClientRect();
            // Center the tapped tab inside the strip so the next/prev tab peeks in
            var delta = (tabRect.left + tabRect.width / 2) - (stripRect.left + stripRect.width / 2);
            tabsStrip.scrollBy({ left: delta, behavior: 'smooth' });
          }

          if (activePanel) {
            activePanel.classList.remove('is-active');
            setTimeout(function () {
              activePanel.setAttribute('hidden', '');
              nextPanel.removeAttribute('hidden');
              var cards = nextPanel.querySelectorAll('.collection-tabs__card');
              cards.forEach(function (card) {
                card.style.animation = 'none';
                void card.offsetWidth;
                card.style.animation = '';
              });
              requestAnimationFrame(function () {
                nextPanel.classList.add('is-active');
              });
            }, 300);
          } else {
            nextPanel.removeAttribute('hidden');
            requestAnimationFrame(function () {
              nextPanel.classList.add('is-active');
            });
          }
        });
      });
    }

    document.querySelectorAll('[data-section-type="collection-tabs"]').forEach(initCollectionTabs);

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-section-type="collection-tabs"]');
      if (section) initCollectionTabs(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
